document.addEventListener("DOMContentLoaded", () => {
  // Footer Element , copyright text z-index issue fix
  setTimeout(() => {
    const smileContainer = document.querySelector("#smile-ui-container");
    if (smileContainer && smileContainer.parentElement) {
      smileContainer.parentElement.style.zIndex = "-1";
    }
  }, 3000);

  // Sticky Header
  const header = document.querySelector("#nayeel-custom-header");
  let lastScrollTop = 0;

  if (header) {
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScrollTop || currentScroll < 110) {
        header.classList.remove("sticky-header");
      } else {
        header.classList.add("sticky-header");
      }

      lastScrollTop = Math.max(currentScroll, 0);
    });
  } else {
    console.warn("Sticky header element not found.");
  }

  // Mobile Menu Toggle
  const mobileMenuButton = document.querySelector("#mobile-menu-open-button");
  const mobileMenuCloseBtn = document.querySelector("#mobile-menu-close-icon");
  const mobileMenu = document.querySelector("#mobile-menu");

  if (mobileMenu && mobileMenuButton && mobileMenuCloseBtn) {
    const toggleMenu = () => mobileMenu.classList.toggle("mobile-menu-open");

    mobileMenuButton.addEventListener("click", toggleMenu);
    mobileMenuCloseBtn.addEventListener("click", toggleMenu);
  } else {
    console.warn("Mobile menu, open button, or close button not found.");
  }
});
